import { render } from "./Release.vue?vue&type=template&id=04d9a4d4&scoped=true"
import script from "./Release.vue?vue&type=script&lang=js"
export * from "./Release.vue?vue&type=script&lang=js"

import "./Release.vue?vue&type=style&index=0&id=04d9a4d4&lang=scss&scoped=true"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d9a4d4"]])

export default __exports__